import PropTypes from 'prop-types';
import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import Panel from '../../../../Panels';
import { computeSearchesStatus } from '../../lib/status';
import { formatCountry } from '../../lib/screenings';
import Record from '../../Record';

const IntlCriminalSearchesV2 = ({ searches, skippedCountries, accountId }) => {
  const renderedSearches = searches || [];
  const skipped = skippedCountries || [];

  // Excluding every resolved country leaves no search behind, so the skip
  // events are the only thing left to tell the reader what happened.
  if (!renderedSearches.length && !skipped.length) {
    return null;
  }

  return (
    <Panel
      data-testid='intl-criminal-searches-v2'
      title={i18n.getStr('components.internationalCriminalSearch')}
      status={
        renderedSearches.length ? computeSearchesStatus(renderedSearches) : ''
      }
    >
      {renderedSearches.map((record, i) => (
        <React.Fragment key={`intl-crim-search-${i + 1}`}>
          <Record
            record={record}
            type='internationalCriminalSearchV2'
            dataTestId={`international-criminal-search-v2-${i + 1}`}
          />
          {i < renderedSearches.length - 1 && <hr />}
        </React.Fragment>
      ))}
      {skipped.length > 0 && (
        <div data-testid='intl-criminal-skipped-countries'>
          {renderedSearches.length > 0 && <hr />}
          <i>{i18n.getStr('components.intlCriminal.skippedCountries')}</i>
          <ul>
            {skipped.map(({ country }) => (
              <li key={country}>{formatCountry(country, accountId)}</li>
            ))}
          </ul>
        </div>
      )}
    </Panel>
  );
};

IntlCriminalSearchesV2.propTypes = {
  searches: PropTypes.array,
  skippedCountries: PropTypes.array,
  accountId: PropTypes.string,
};

IntlCriminalSearchesV2.defaultProps = {
  searches: [],
  skippedCountries: [],
  accountId: '',
};

export default IntlCriminalSearchesV2;
